import { render, staticRenderFns } from "./Jablotron.vue?vue&type=template&id=283e7257&scoped=true&"
import script from "./Jablotron.vue?vue&type=script&lang=js&"
export * from "./Jablotron.vue?vue&type=script&lang=js&"
import style0 from "./Jablotron.vue?vue&type=style&index=0&id=283e7257&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283e7257",
  null
  
)

export default component.exports